import {Component, Input, OnInit} from '@angular/core';
import {EventPageStateService} from "@biletix/features/event/services/event-page-state.service";
import {BtxPerformanceListItem} from "@biletix/core/models/event/performance-list-item.model";
import {EventService} from "@biletix/core/services/event.service";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {Ga4EcommerceService} from "@biletix/core/services/ga4-ecommerce.service";
import {
    Ga4Item,
    buildGa4EventItem,
    resolveListItemPrice,
} from "@biletix/core/common/utils/ga4-ecommerce.util";
import {map} from "rxjs/operators";

@Component({
    standalone: false,
    selector: 'btx-performance-list',
    templateUrl: './performance-list.component.html',
    styleUrls: ['./performance-list.component.scss']
})
export class PerformanceListComponent extends AbstractionComponent implements OnInit {

    @Input() eventCode!: string;
    @Input() eventName!: string;
    @Input() region?: string;
    @Input() lang?: string;
    @Input() definitionCode?: string;

    performanceList: BtxPerformanceListItem[] = [];
    calendarOrListStatus:boolean = false;
    parentEventFlexibleTime: boolean = false;


    /** GA4 `item_list_id`; dile/bölgeye bağlı olmayan sabit liste kimliği. */
    private static readonly GA4_LIST_ID = 'event_performance_list';

    constructor(private eventPageStateService: EventPageStateService,
                private eventService: EventService,
                private ga4: Ga4EcommerceService) {
        super();
    }

    ngOnInit() {
        const performances = this.eventPageStateService.getCurrentPerformanceList();
        if (performances && performances.length > 0) {
            //TODO: Status enum oluşturulmalı.
            performances.forEach(item => item.active = item.status == 's01_onsale');
        }
        this.performanceList = performances;
        this.calendarOrListStatus = performances.length >= 5;
        this.parentEventFlexibleTime = this.eventPageStateService.getCurrentEventDetail().flexibleTimeEventCheck;
        this.pushViewItemList();
    }

    /**
     * Performans listesi için GA4 `view_item_list` gönderir.
     *
     * Liste 5+ performansta takvim görünümüyle başlıyor; event yine tüm
     * performanslar için gönderilir, çünkü iki görünüm de aynı ürün kümesini
     * kullanıcıya sunuyor ve görünüm değişimi yeni bir liste değil.
     */
    private pushViewItemList(): void {
        this.ga4.pushViewItemList(
            PerformanceListComponent.GA4_LIST_ID,
            PerformanceListComponent.GA4_LIST_ID,
            this.performanceList.map((item, index) => this.toGa4Item(item, index))
        );
    }

    /**
     * Performans satırına tıklandığında GA4 `select_item` gönderir.
     *
     * Handler `btx-list-item` host elemanında dinlenir; satırdaki bağlantı
     * `[href]` ile tam sayfa yüklemesi yaptığı için teslim garanti değildir
     * (bkz. `Ga4EcommerceService.pushSelectItem`).
     */
    onItemSelect(item: BtxPerformanceListItem, index: number): void {
        this.ga4.pushSelectItem(
            PerformanceListComponent.GA4_LIST_ID,
            PerformanceListComponent.GA4_LIST_ID,
            this.toGa4Item(item, index)
        );
    }

    /**
     * `item_id` performans tarihini de içerir: kullanıcı burada tek bir
     * performans seçtiği için performans sayfasındaki `view_item` ile aynı
     * kimlik üretilir.
     */
    private toGa4Item(item: BtxPerformanceListItem, index: number): Ga4Item {
        return buildGa4EventItem({
            eventCode: item.eventCode,
            eventName: item.eventName || item.shortName,
            performanceDate: item.performanceDate,
            // `minPrice` kuruş, `priceInfo` biçimlenmiş metin — ayrı ölçekler.
            price: resolveListItemPrice(item.minPrice, item.priceInfo),
            venueName: item.venueName,
            index,
        });
    }

}
